/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'

const BACKEND = (process.env.REACT_APP_API_URL || 'https://api.qwiksurv.com/api').replace(/\/api\/?$/, '')

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()

  const photoUrl = currentUser?.photo
    ? currentUser.photo.startsWith('http') || currentUser.photo.startsWith('data:') ? currentUser.photo : `${BACKEND}${currentUser.photo}`
    : null

  const initials =
    (currentUser?.first_name?.[0] ?? '') + (currentUser?.last_name?.[0] ?? '') || 'A'

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {photoUrl ? (
              <img
                alt='Avatar'
                src={photoUrl}
                style={{width:50, height:50, borderRadius:'50%', objectFit:'cover'}}
              />
            ) : (
              <div
                className='d-flex align-items-center justify-content-center rounded-circle fw-bold text-white'
                style={{width:50, height:50, background:'linear-gradient(135deg,#6340C8,#8B5CF6)', fontSize:18}}
              >
                {initials}
              </div>
            )}
          </div>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.first_name} {currentUser?.last_name}
            </div>
            <span className='fw-bold text-muted fs-7'>{currentUser?.email}</span>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5 my-1'>
        <Link to='/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
